<template>
  <div id="scale-view">
    <div v-if="type === 'mm'" class="scale scale-mm" v-tooltip="'Precipitación en milímetros'">
      <div class="class" style="background-color: #ffffff"><div>0</div></div>
      <div class="class" style="background-color: #d8ffff"><div>20</div></div>
      <div class="class" style="background-color: #9df9ff"><div>40</div></div>
      <div class="class" style="background-color: #5cf3ff"><div>60</div></div>
      <div class="class" style="background-color: #22e6ff"><div>80</div></div>
      <div class="class" style="background-color: #37d4ff"><div>100</div></div>
      <div class="class" style="background-color: #17c7ed"><div>120</div></div>
      <div class="class" style="background-color: #30c7dc"><div>140</div></div>
      <div class="class" style="background-color: #35b5d7"><div>160</div></div>
      <div class="class" style="background-color: #2890dd"><div>180</div></div>
      <div class="class" style="background-color: #1c6ce3"><div>200</div></div>
      <div class="class" style="background-color: #0e45f1"><div>220</div></div>
      <div class="class" style="background-color: #001eff"><div>240</div></div>
      <div class="class" style="background-color: #0016ff"><div>260</div></div>
      <div class="class" style="background-color: #020ef2"><div>280</div></div>
      <div class="class" style="background-color: #0b02bf"><div>300</div></div>
      <div class="class" style="background-color: #1b00cc"><div>320</div></div>
      <div class="class" style="background-color: #8168cd"><div>340</div></div>
      <div class="class" style="background-color: #5f4bbf"><div>360</div></div>
      <div class="class" style="background-color: #522fce"><div>380</div></div>
      <div class="class" style="background-color: #4315ae"><div>400</div></div>
      <div class="class" style="background-color: #3b0098"><div>420</div></div>
      <div class="class" style="background-color: #4c0083"><div>440</div></div>
      <div class="class" style="background-color: #470069"><div>460</div></div>
      <div class="class" style="background-color: #2b004c"><div>480</div></div>
      <div class="class" style="background-color: #10012e"><div>500</div></div>
      <div class="class" style="background-color: #073c07"><div>520</div></div>
      <div class="class" style="background-color: #035303"><div>540</div></div>
      <div class="class" style="background-color: #076807"><div>560</div></div>
      <div class="class" style="background-color: #049104"><div>580</div></div>
      <div class="class" style="background-color: #03c003"><div>600</div></div>
      <div class="class" style="background-color: #0aff0a"><div>620</div></div>
      <div class="class" style="background-color: #cffc02"><div>640</div></div>
      <div class="class" style="background-color: #edff06"><div>660</div></div>
      <div class="class" style="background-color: #fffb04"><div>680</div></div>
      <div class="class" style="background-color: #ffe807"><div>700</div></div>
      <div class="class" style="background-color: #ffc504"><div>720</div></div>
      <div class="class" style="background-color: #ff9918"><div>740</div></div>
      <div class="class" style="background-color: #ff742a"><div>760</div></div>
      <div class="class" style="background-color: #ff5830"><div>780</div></div>
      <div class="class" style="background-color: #ff2d08"><div>800</div></div>
    </div>
    <div v-if="type === '°C'" class="scale scale-c" v-tooltip="'Temperatura en grados centígrados'">
      <div class="class" style="background-color: #2b83ba">-10</div>
      <div class="class" style="background-color: #3c8fb7">-8</div>
      <div class="class" style="background-color: #4d9bb4">-6</div>
      <div class="class" style="background-color: #5ea7b1">-4</div>
      <div class="class" style="background-color: #6fb3ae">-2</div>
      <div class="class" style="background-color: #80bfac">0</div>
      <div class="class" style="background-color: #91cba9">2</div>
      <div class="class" style="background-color: #a3d7a6">4</div>
      <div class="class" style="background-color: #b1e0a6">6</div>
      <div class="class" style="background-color: #bce4aa">8</div>
      <div class="class" style="background-color: #c7e9ad">10</div>
      <div class="class" style="background-color: #d3edb1">12</div>
      <div class="class" style="background-color: #def2b4">14</div>
      <div class="class" style="background-color: #e9f6b8">16</div>
      <div class="class" style="background-color: #f4fbbc">18</div>
      <div class="class" style="background-color: #ffffbf">20</div>
      <div class="class" style="background-color: #fff5b3">22</div>
      <div class="class" style="background-color: #ffeaa6">24</div>
      <div class="class" style="background-color: #ffdf9a">26</div>
      <div class="class" style="background-color: #fed48d">28</div>
      <div class="class" style="background-color: #fec980">30</div>
      <div class="class" style="background-color: #febe74">32</div>
      <div class="class" style="background-color: #feb467">34</div>
      <div class="class" style="background-color: #fba45c">36</div>
      <div class="class" style="background-color: #f69053">38</div>
      <div class="class" style="background-color: #f17c4a">40</div>
      <div class="class" style="background-color: #ec6841">42</div>
      <div class="class" style="background-color: #e75437">44</div>
      <div class="class" style="background-color: #e2402e">46</div>
      <div class="class" style="background-color: #dc2d25">48</div>
      <div class="class" style="background-color: #d7191c">50</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScaleView',

  props: {
    type: {
      default: 'mm',
    },
  },
};
</script>

<style lang="scss">
@import '../styles/variables.scss';

#scale-view {
  width: 100%;
  height: 100%;
  border-radius: $border-radius;
  overflow: hidden;

  .scale {
    width: 100%;
    height: 100%;
    display: flex;

    .class {
      text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-grow: 1;
      font-size: 12px;

      div {
        transform: rotate(-90deg);
      }
    }
  }
}
</style>
